// extracted by mini-css-extract-plugin
export default {"ShippingFields":"shipping-fields-styles__ShippingFields__bSSrF"};